(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('TipoOrdenamientoSearch', TipoOrdenamientoSearch);

    TipoOrdenamientoSearch.$inject = ['$resource'];

    function TipoOrdenamientoSearch($resource) {
        var resourceUrl =  'api/_search/tipo-ordenamientos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
